import { Box, Stack, Typography } from "@mui/material";

import {
  OperationActionConfig,
  OperationInventoryStock,
  OperationRecord,
  OperationTab,
} from "../types";
import OperationDataTable from "./OperationDataTable";

interface OperationPanelProps {
  title: string;
  description: string;
  tab: OperationTab;
  rows: OperationRecord[];
  loading: boolean;
  inventoryStocks: OperationInventoryStock[];
  stockTransfers: OperationRecord[];
  onAction: (record: OperationRecord, action: OperationActionConfig) => void;
  onView: (record: OperationRecord) => void;
}

const OperationPanel = ({
  title,
  description,
  tab,
  rows,
  loading,
  inventoryStocks,
  stockTransfers,
  onAction,
  onView,
}: OperationPanelProps) => (
  <Box mt={2}>
    <Stack mb={1.25} spacing={0.25}>
      <Typography variant="h6" fontWeight={800}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">{description}</Typography>
    </Stack>
    <OperationDataTable
      tab={tab}
      rows={rows}
      loading={loading}
      inventoryStocks={inventoryStocks}
      stockTransfers={stockTransfers}
      onAction={onAction}
      onView={onView}
    />
  </Box>
);

export default OperationPanel;
